module.exports = __webpack_public_path__ + "af84065b4e30af6788ed85b735464d54.svg";